import React from "react";
import {Link} from "react-router-dom";
import ArticlesDashboard from "./pages/ArticlesDashboard";

const Articles = () => {
    return (
        <>
            <div className="container container-xxl">
                <div className="pagetitle d-flex justify-content-between">
                    <h1><i className="bi bi-file-medical"></i> Articles</h1>
                    <div>
                        <Link to="/articles/new" className="btn btn-sm btn-outline-primary me-2">
                            <i className="bi bi-plus"></i> Draft New Article
                        </Link>
                        <Link to="/articles/category" className="btn btn-sm btn-outline-secondary">
                            <i className="bi bi-gear"></i> Manage Article Category
                        </Link>

                    </div>
                </div>
                <ArticlesDashboard/>
            </div>
        </>
    );
};

export default Articles;
